import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const chartLines = [
  { key: "views", label: "Profile Views", color: "#2563eb" },
  { key: "likes", label: "Profile Likes", color: "#22c55e" },
  { key: "projects", label: "Portfolio Projects", color: "#f59e42" },
];

export const AnalyticsDashboardChart: React.FC<{ data?: any[] }> = ({ data = [] }) => {
  const [visible, setVisible] = React.useState({
    views: true,
    likes: true,
    projects: true,
  });

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 md:p-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6 mb-4">
        <div className="flex gap-6 md:gap-6">
          {chartLines.slice(0, 2).map((line) => (
            <label key={line.key} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={visible[line.key as keyof typeof visible]}
                onChange={() =>
                  setVisible((v) => ({ ...v, [line.key]: !v[line.key as keyof typeof visible] }))
                }
                className="accent-current"
              />
              <span
                className="text-xs md:text-sm font-medium flex items-center gap-1"
                style={{ color: line.color }}
              >
                <span
                  className="inline-block w-3 h-3 rounded-full"
                  style={{ background: line.color }}
                />
                {line.label}
              </span>
            </label>
          ))}
        </div>
        {chartLines.slice(2).map((line) => (
          <label key={line.key} className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={visible[line.key as keyof typeof visible]}
              onChange={() =>
                setVisible((v) => ({ ...v, [line.key]: !v[line.key as keyof typeof visible] }))
              }
              className="accent-current"
            />
            <span
              className="text-xs md:text-sm font-medium flex items-center gap-1"
              style={{ color: line.color }}
            >
              <span
                className="inline-block w-3 h-3 rounded-full"
                style={{ background: line.color }}
              />
              {line.label}
            </span>
          </label>
        ))}
      </div>
      <div className="w-full h-80 md:h-96">
        <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 30, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip
            content={({ active, payload, label }) => {
              if (!active || !payload) return null;
              return (
                <div className="bg-white border border-gray-200 rounded-lg p-3 shadow min-w-[170px]">
                  <div className="font-semibold text-black text-base mb-3">Date: {label}</div>
                  {chartLines.map((line) => (
                    visible[line.key as keyof typeof visible] && (
                      <div
                        key={line.key}
                        className="text-sm mb-1"
                        style={{ color: line.color }}
                      >
                        {line.label}: <span className="font-bold">{payload.find((e: any) => e.dataKey === line.key)?.value ?? 0}</span>
                      </div>
                    )
                  ))}
                </div>
              );
            }}
          />
          {chartLines.map(
            (line) =>
              visible[line.key as keyof typeof visible] && (
                <Line
                  key={line.key}
                  type="monotone"
                  dataKey={line.key}
                  stroke={line.color}
                  strokeWidth={2}
                  dot={{ r: 3 }}
                  activeDot={{ r: 5 }}
                />
              )
          )}
        </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}; 
